<template>
    <div>
        <v-row justify="center" class="pt-16">
            <v-col cols="12">
                <v-row justify="center">
                    <v-col cols="12" class="pa-0">
                        <v-img src="../../assets/images/intropage.png" cover height="100%" width="auto">
                            <v-row justify="center" class="text-left fill-height">
                                <v-col cols="10" align-self="center">
                                    <v-row justify="center" class="fill-height">
                                        <v-col cols="12" align-self="center" class="headerrrrrrrrr pt-16">
                                            <span>Welcome to</span>
                                        </v-col>
                                        <v-col cols="12" class="headone">
                                            <span>
                                                St Antony’s Pilgrim Church <br>
                                                Chengalam
                                            </span>
                                        </v-col>
                                        <v-col cols="12" class="headtwo">
                                            <span>
                                                Lorem ipsum dolor sit amet consectetur. Purus lorem ac <br> cuimentum risus.
                                                Massa
                                                ut leo in
                                                turpis.

                                            </span>
                                        </v-col>

                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-img>
                    </v-col>
                </v-row>
                <!-- <v-row justify="center" class="bghome">
                    <v-col cols="12">
                        <v-row justify="center" class="py-10">
                            <v-col cols="10">
                                <v-row justify="start">
                                    <v-col cols="12" lg="10">
                                        <span class="hdtw">Lorem ipsum dolor sit amet consectetur.</span><br>
                                        <span class="headtwo">Lorem ipsum dolor sit amet consectetur. Purus lorem ac
                                            curabitur in
                                            tortor condimentum. Aliquam pharetra cursus nec at lectus scelerisque. Quis
                                            malesuada
                                            sed turpis amet dictum condimentum risus. Massa ut leo in turpis.</span>
                                    </v-col>
                                    <v-col cols="12" lg="2" align-self="center">
                                        <v-btn color="red">Watch Live&nbsp;<v-icon>mdi-antenna</v-icon></v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row> -->
                <v-row justify="center" class="bghome">
                    <v-col cols="12">
                        <v-row justify="center">
                            <v-col cols="10">
                                <v-row justify="center">
                                    <v-col cols="12">
                                        <v-row justify="center">
                                            <v-col cols="12" lg="3" sm="3">
                                                <v-row justify="center">
                                                    <v-col cols="12">
                                                        <v-img src="../../assets/images/iphonefull.png" width="100%"
                                                            height="auto"></v-img>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-col cols="12" lg="6" sm="6" class="py-lg-10 py-md-10 py-sm-10">
                                                <v-row justify="center">
                                                    <v-col cols="12" class="text-center ads">
                                                        <span>Introducing our new Church Directory App</span>
                                                    </v-col>
                                                    <v-col cols="12" class="text-center adssub">
                                                        <span>Now avilable on </span>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-row justify="center">
                                                            <v-col cols="12" lg="4" sm="4">
                                                                <a href="https://play.google.com/store/apps/details?id=com.leopardtechlabs.churchdirectory">
                                                                    <v-img src="../../assets/images/playsore.png"></v-img>
                                                                </a>
                                                            </v-col>

                                                            <v-col cols="12" lg="4" sm="4">
                                                                <a href="https://apps.apple.com/in/app/st-antonys-church-chengalam/id6476023538">
                                                                <v-img src="../../assets/images/appstore.png"></v-img>
                                                            </a>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-col cols="12" lg="3" sm="3">
                                                <v-row justify="center">
                                                    <v-col cols="12">
                                                        <v-img src="../../assets/images/logoad.png"></v-img>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>
<style>
.headerrrrrrrrr {
    font-family: interregular;
    font-size: 24px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
}

.headone {
    font-family: latoregular;
    font-size: 55px;
    font-weight: 800;
    color: rgba(255, 255, 255, 1);
}

.headtwo {
    font-family: interregular;
    font-size: 18px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
}

.bghome {
    background: linear-gradient(180deg, #094875 0%, #1B5F8F 100%);
}

.hdtw {
    font-family: interregular;
    font-size: 22px;
    font-weight: 700;
    color: rgba(255, 255, 255, 1);
}

.st1 {
    font-family: interregular;
    font-size: 22px;
    font-weight: 700;
    color: rgba(60, 116, 185, 1);
}

.st2 {
    font-family: interregular;
    font-size: 22px;
    font-weight: 600;
    color: rgba(38, 38, 38, 1);
}

.st3 {
    font-family: interregular;
    font-size: 18px;
    font-weight: 500;
    color: rgba(62, 62, 62, 1);
}

.st4 {
    font-family: interregular;
    font-size: 18px;
    font-weight: 700;
    color: rgba(60, 116, 185, 1);
}

.underline {
    text-decoration: underline;
    color: rgba(255, 168, 0, 1);
}

.ads {
    font-family: interregular;
    font-size: 30px;
    font-weight: 500;
    color: white;
}

.adssub {
    font-family: interregular;
    font-size: 18px;
    font-weight: 500;
    color: white;
}
</style>